import axios, { CancelToken } from 'axios';

const archiveFilterButtons = document.querySelectorAll('.deepsea-archive-filters-button');
const archiveFilterReset = document.querySelector('.deepsea-archive-filters-reset');
const archiveFilterList = document.querySelectorAll('.deepsea-archive-filters-list');
const archiveSearchForm = document.querySelector('.archive-search-form');
const archivePostsList = document.querySelector('.archive-posts-list');
const resourcesPostsList = document.querySelectorAll('.resources-posts-list');
const archiveSearchInput = document.querySelector('.search input[type="search"]');

if (archiveFilterButtons.length > 0) {
  Array.from(archiveFilterButtons).forEach((button) => {
    button.addEventListener('click', (e) => {
      const taxonomy = e.currentTarget.getAttribute('data-taxonomy');

      button.classList.toggle('opened');
      document
        .querySelector(`.deepsea-archive-filters-list[data-taxonomy="${taxonomy}"]`)
        .classList.toggle('opened');
    });
  });

  document.addEventListener('click', (e) => {
    Array.from(archiveFilterButtons).forEach((button) => {
      const taxonomy = button.getAttribute('data-taxonomy');
      const filterList = document.querySelector(
        `.deepsea-archive-filters-list[data-taxonomy="${taxonomy}"]`,
      );

      if (!button.contains(e.target) && !filterList.contains(e.target)) {
        button.classList.remove('opened');
        filterList.classList.remove('opened');
      }
    });
  });
}

if (archiveSearchForm !== null) {
  let searchQuery = '';
  let filtersArray = [];
  let portfolioStatusArray = [];
  let source;
  let results;
  let isInfiniteScrollLoading = false;

  const handleResourcesRequest = async () => {
    let response;
    const requestURL = `/wp-json/deepsea/v1/archive-search-filters?post_type=resources&s=${searchQuery}`;

    try {
      if (source) {
        source.cancel();
      }

      source = CancelToken.source();
      response = await axios.get(requestURL, {
        cancelToken: source.token,
      });

      results = response.data;
    } catch (error) {
      if (axios.isCancel(error)) {
        // eslint-disable-next-line no-console
        console.log('Request canceled');
      } else {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    }
  };

  const handleResourcesDisplayResults = () => {
    Array.from(resourcesPostsList).forEach((resourcesList) => {
      const type = resourcesList.getAttribute('data-type');
      const button = resourcesList.nextElementSibling;
      // eslint-disable-next-line no-param-reassign
      resourcesList.innerHTML = results[type];
      if (searchQuery !== '') {
        button.style.display = 'none';
      } else {
        button.style.display = 'block';
      }
    });
  };

  const handleRequest = async (page) => {
    const postType = archiveSearchForm.getAttribute('data-post-type');
    const category = archiveSearchForm.getAttribute('data-category');
    const perPage = archivePostsList.getAttribute('data-per-page');

    let response;
    let requestURL = `/wp-json/deepsea/v1/archive-search-filters?post_type=${postType}&s=${searchQuery}&page=${page}&per_page=${perPage}`;

    try {
      if (source) {
        source.cancel();
      }

      source = CancelToken.source();
      if (postType === 'people') {
        requestURL = `${requestURL}&people-department=${filtersArray.join(',')}`;
      } else if (postType === 'post') {
        requestURL = `${requestURL}&category_name=${category}&insight-type=${filtersArray.join(
          ',',
        )}`;
      } else if (postType === 'portfolio') {
        requestURL = `${requestURL}&sectors=${filtersArray.join(
          ',',
        )}&portfolio-status=${portfolioStatusArray.join(',')}`;
      } else {
        requestURL = `${requestURL}&sectors=${filtersArray.join(',')}`;
      }

      response = await axios.get(requestURL, {
        cancelToken: source.token,
      });

      results = response.data;
      archivePostsList.setAttribute('data-total-pages', results.max_num_pages);
    } catch (error) {
      if (axios.isCancel(error)) {
        // eslint-disable-next-line no-console
        console.log('Request canceled');
      } else {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    }
  };

  const handleDisplayResults = (isInfiniteScroll = false) => {
    if (!isInfiniteScroll) {
      archivePostsList.innerHTML = results.html;
    } else {
      archivePostsList.insertAdjacentHTML('beforeend', results.html);
    }
  };

  const handleInfiniteScroll = () => {
    let page = parseInt(archivePostsList.getAttribute('data-page'), 10);
    const totalPages = archivePostsList.getAttribute('data-total-pages');

    if (page < totalPages && isInfiniteScrollLoading === false) {
      isInfiniteScrollLoading = true;
      page += 1;
      archivePostsList.setAttribute('data-page', page);

      handleRequest(page).then(() => {
        isInfiniteScrollLoading = false;
        handleDisplayResults(true);
      });
    }
  };

  const searchInput = archiveSearchForm.querySelector('input[type="search"]');

  const handleResetButtonStyle = () => {
    if (
      filtersArray.length > 0 ||
      portfolioStatusArray.length > 0 ||
      searchInput.value.length > 0
    ) {
      archiveFilterReset.classList.add('active');
    } else {
      archiveFilterReset.classList.remove('active');
    }
  };

  searchInput.addEventListener('input', handleResetButtonStyle);

  // Add event listener to the reset button if it exists
  if (archiveFilterReset) {
    archiveFilterReset.addEventListener('click', () => {
      if (searchInput.value.length > 0) {
        searchInput.value = '';
        searchQuery = '';
      }

      handleResetButtonStyle();
    });
  }

  archiveSearchForm.addEventListener('input', () => {
    searchQuery = searchInput.value;

    if (archivePostsList !== null) {
      archivePostsList.setAttribute('data-page', '1');
      handleRequest(1).then(handleDisplayResults);
    }

    if (archiveSearchForm.getAttribute('data-post-type') === 'resources') {
      handleResourcesRequest().then(handleResourcesDisplayResults);
    }
  });

  searchInput.addEventListener('keydown', (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  });

  if (archiveSearchInput !== null) {
    archiveSearchInput.addEventListener('search', (e) => {
      if (e.target.value === '') {
        searchQuery = '';

        if (archivePostsList !== null) {
          handleRequest(1).then(handleDisplayResults);
        }

        if (resourcesPostsList.length > 0) {
          handleResourcesRequest().then(handleResourcesDisplayResults);
        }
      }
    });
  }

  if (archiveFilterList.length > 0) {
    Array.from(archiveFilterList).forEach((filterList) => {
      const taxonomy = filterList.getAttribute('data-taxonomy');
      const archiveFilterCheckboxes = filterList.querySelectorAll(
        '.deepsea-archive-filters-list-item input[type="checkbox"]',
      );

      Array.from(archiveFilterCheckboxes).forEach((checkbox) => {
        checkbox.addEventListener('change', (e) => {
          const filterSlug = e.target.getAttribute('name');

          if (taxonomy === 'portfolio-status') {
            if (e.target.checked) {
              portfolioStatusArray.push(filterSlug);
            } else {
              portfolioStatusArray = portfolioStatusArray.filter((slug) => slug !== filterSlug);
            }
          } else if (e.target.checked) {
            filtersArray.push(filterSlug);
          } else {
            filtersArray = filtersArray.filter((slug) => slug !== filterSlug);
          }

          handleResetButtonStyle();

          archivePostsList.setAttribute('data-page', '1');
          handleRequest(1).then(handleDisplayResults);
        });
      });
    });
  }

  if (archiveFilterReset !== null) {
    archiveFilterReset.addEventListener('click', (e) => {
      e.preventDefault();

      Array.from(
        document.querySelectorAll('.deepsea-archive-filters-list-item input[type="checkbox"]'),
      ).forEach((checkbox) => {
        // eslint-disable-next-line no-param-reassign
        checkbox.checked = false;
      });

      archivePostsList.setAttribute('data-page', '1');
      filtersArray = [];
      portfolioStatusArray = [];

      handleResetButtonStyle();

      handleRequest(1).then(handleDisplayResults);
    });
  }

  if (archivePostsList !== null) {
    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;
      const archivePostsListOffsetTop = archivePostsList.offsetTop;
      const archivePostsListHeight = archivePostsList.offsetHeight;
      const page = archivePostsList.getAttribute('data-page');

      if (scrollPosition > archivePostsListOffsetTop + archivePostsListHeight - 450) {
        handleInfiniteScroll(page);
      }
    });
  }
}
